import * as React from 'react';

import {CTABanner} from '../../cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {SlackIcon} from '../../icon/svg/slack-icon';

import styles from './slack-auth-banner.module.css';

type Props = {
    width?: number;
    text: string;
};

export function SlackAuthBanner(props: Props) {
    const onClick = () => {
        const form = document.getElementById('slackConnect');

        // @ts-expect-error
        if (form && typeof form.submit === 'function') form.submit();
    };

    return (
        <div style={{width: props.width}} className={styles['banner-container']}>
            <form action='/setup/instant-integration/edit' id='slackConnect'>
                <input type='hidden' name='integrationType' value='Slack' />
                <input type='hidden' name='userData[returnTo]' value={window.location.pathname} />
                <CTABanner
                    icon={SlackIcon}
                    title='Update your team with Slack notifications'
                    text={props.text}
                    buttonText='Connect with Slack'
                    maxWidth={null}
                    onPrimaryAction={onClick}
                />
            </form>
        </div>
    );
}
